<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout column>
      <v-flex xs12 style="flex-basis: auto">
        <v-toolbar>
          <div style="flex: 1 1 100%; display: flex; flex-wrap: nowrap; justify-content: space-between; align-items: center;">
            <v-expand-x-transition>
              <v-toolbar-title v-show="!searchVisible">
                Dashboard
              </v-toolbar-title>
            </v-expand-x-transition>

            <v-expand-x-transition>
              <v-text-field
                v-show="searchVisible"
                placeholder="Cautare"
                clearable
                hide-details
                solo
                flat
                append-icon="mdi-send"
                :loading="loading"
                @click:append="_cbSearch"
                @keydown.enter="_cbSearch"
                :suffix="String(total)"
                v-model="searchTerm">
              </v-text-field>
            </v-expand-x-transition>

            <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: nowrap;">
              <v-btn icon @click.stop="searchVisible = !searchVisible" :color="onColor" flat key="search" title="Cauta simboluri">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>

              <v-btn icon @click="_cbAddEntity" title="Adauga simbol">
                <v-icon :color="onColor">
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-btn icon @click="uplaodXLSX" :color="onColor" flat key="xlsx-up" title="Upload simboluri din xlsx">
                <v-icon>mdi-file-upload-outline</v-icon>
              </v-btn>

              <v-btn icon @click.stop="downloadDialog = true; downloadStats.snack = false;" :color="onColor" flat title="Deschide meniul de descarcare">
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn icon @click.stop="settingsDialog = true" :color="onColor" flat title="Deschide meniul de setari">
                <v-icon>mdi-cogs</v-icon>
              </v-btn>
              <v-btn icon @click="openFiltersDialog">
                <v-badge color="error" :value="totalFiltersLength">
                  <template v-slot:badge>
                    <span class="caption">{{ totalFiltersLength }}</span>
                  </template>
                  <v-icon :color="filtersStateColor">
                    {{ totalFiltersLength ? 'mdi-filter' : 'mdi-filter-off' }}
                  </v-icon>
                </v-badge>
              </v-btn>
              <v-btn icon class="ma-0" :title="showGallery ? 'Ascunde panoul de fisiere' : 'Arata panoul de fisiere'" @click="toggleGallery">
                <v-icon small>{{ showGallery ? 'mdi-arrow-collapse-right' : 'mdi-arrow-collapse-left' }}</v-icon>
              </v-btn>
            </div>
          </div>
        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <split-pane :min-percent="10" :default-percent="paneHorizontal" :split="$vuetify.breakpoint.smAndDown ? 'horizontal' : 'vertical'" @resize="paneResize($event, 'horizontal')">
          <template slot="paneL">
            <v-card flat class="ma-0 pa-0" style="display: flex; flex-direction: column; height: 100%">
              <!-- <v-card-title class="ma-0 pa-0">
                <v-toolbar dense flat>
                  <v-toolbar-title>
                    Simboluri
                  </v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn icon class="ma-0" :title="showGallery ? 'Ascunde panoul de fisiere' : 'Arata panoul de fisiere'" @click="toggleGallery">
                    <v-icon small>{{ showGallery ? 'mdi-arrow-collapse-right' : 'mdi-arrow-collapse-left' }}</v-icon>
                  </v-btn>
                </v-toolbar>
              </v-card-title> -->
              <v-card-text class="symbol-container" :class="{ 'delete-enabled': deleteSymbolsEnabled, 'light': light, 'dark': !light }" v-if="entityDisplayMode === 'gallery'">
                <template v-for="item in items">
                  <div class="item" :key="item._id" @click="_cbSelectDeleteSymbolProxy(item)" :class="{
                    'selected': isSelectedItem(item),
                    'to-delete': toDeleteSymbols.includes(item._id),
                    'blue-grey--text': !isSelectedItem(item) && light,
                    'grey--text text--lighten-2': !isSelectedItem(item) && !light
                  }">
                    <div class="avatar">
                      <img :src="getSrc(item)" loading="lazy" decoding="async">
                    </div>
                    <div class="content">
                      <div class="text-truncation one-line">
                        {{item.id_scara}}
                      </div>
                      <div class="controls">
                        <div class="text-truncation one-line" :title="`${item.photos.length} poze, ${item.pdfs ? item.pdfs.length : 0} fisiere pdf, ${item.excels ? item.excels.length : 0} fisiere excel`">
                          <v-icon :size="12" :color="offColor">mdi-camera</v-icon>
                          {{item.photos.length}}

                          <v-icon :size="12" :color="offColor">mdi-file-pdf-box</v-icon>
                          {{item.pdfs ? item.pdfs.length : 0}}

                          <v-icon :size="12" :color="offColor">mdi-file-excel</v-icon>
                          {{item.excels ? item.excels.length : 0}}
                        </div>
                      </div>
                      <div class="controls">
                        <div class="text-truncation one-line">
                          <v-icon :size="12" :color="offColor" :title="'Ultima actualizare (incluzand adaugare/sterge poze/fisiere): ' + formatLongDateTime(item.updatedAt)">mdi-update</v-icon>
                          {{ formatLongDateTime(item.updatedAt) }}
                        </div>
                      </div>
                      <div class="controls">
                        <div class="text-truncation one-line">
                          <v-icon :size="12" :color="offColor" :title="'Ultima actualizare facuta de: ' + (item.user || 'probabil admin')">mdi-account</v-icon>
                          {{ item.user || 'neatins'}}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </v-card-text>
              <v-card-text class="map-container pa-0" v-else>
                <entity-map @marker-clicked="markerClicked"/>
              </v-card-text>
              <v-card-actions v-if="entityDisplayMode === 'gallery'">
                <v-spacer></v-spacer>
                <v-pagination
                  style="justify-content: center"
                  v-model="page"
                  :length="totalPages"
                  :total-visible="5"
                  circle
                ></v-pagination>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </template>

          <template slot="paneR" v-if="showGallery">
            <split-pane :min-percent="10" :default-percent="paneVertical" split="horizontal" @resize="paneResize($event, 'vertical')">
              <template slot="paneL">
                <v-card flat class="ma-0 pa-0" style="display: flex; flex-direction: column; height: 100%">
                  <!-- <v-card-title class="ma-0 pa-0">
                    <v-toolbar dense flat extended>
                      <v-toolbar-title>Galerie ({{selectedItems.length || items.length}} simboluri {{ selectedItems.length ? ' selectate' : 'pe pagina' }})</v-toolbar-title>

                      <v-btn icon v-if="selectedItems.length" class="ma-0 ml-1" title="Deselecteaza toate simbolurile" @click="clearSelected">
                        <v-icon small color="error">mdi-close</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>

                      <v-btn icon :title="showPreview ? 'Ascunde panoul de preview' : 'Arata panoul de preview'" @click="togglePreview($event, null)">
                        <v-icon small>{{ showPreview ? 'mdi-arrow-collapse-down' : 'mdi-arrow-collapse-up' }}</v-icon>
                      </v-btn>

                      <template v-slot:extension>
                        <v-progress-linear height="100%" :color="light ? '#d8d8d8' : '#383838'" :value="+info.usedPercentage" style="text-align: center; align-self: center">
                          <div style="display: flex; align-items: center; justify-content: space-around; height: 100%">
                            <v-icon small :color="onColor">mdi-server-network</v-icon>
                            {{ info.freeGb }}B liberi ({{ info.freePercentage }}%) din {{ info.totalGb }}B
                            <span>
                              <v-icon small :color="tab === 'photos' ? onColor : offColor">mdi-image</v-icon>
                              {{ info.photos }}B
                              <v-icon small :color="tab === 'pdfs' ? onColor : offColor">mdi-file-pdf-box</v-icon>
                              {{ info.pdfs }}B
                              <v-icon small :color="tab === 'excels' ? onColor : offColor">mdi-file-excel</v-icon>
                              {{ info.excels }}B
                            </span>
                            <v-icon small @click="refreshInfo">mdi-refresh</v-icon>
                          </div>
                        </v-progress-linear>
                      </template>
                    </v-toolbar>
                  </v-card-title> -->
                  <v-card-text style="flex-grow: 1; overflow-y: auto;" class="pa-0" v-if="!showEdit">
                    <template v-if="tab === 'photos'">
                      <template v-if="showPreview">
                        <div class="file-container" :class="{ 'delete-enabled': deleteEnabled, 'light': light, 'dark': !light }">
                          <template v-for="photo in visiblePhotos">
                            <div class="item" :key="photo.key" :class="photo.classList" @click="_cbSelectDeletePhotoProxy(photo.itemId, photo.photo)">
                              <div class="avatar">
                                <img :src="photo.thumb" loading="lazy" decoding="async">
                              </div>
                              <div class="content">
                                <div class="text-truncation two-line" :title="'Denumire: ' + photo.filename + ', fisier: ' + photo.photo">
                                  {{ photo.filename }}
                                </div>
                                <div class="text-truncation one-line">
                                  <v-icon :title="'Incarcata de: ' + photo.author">mdi-camera</v-icon>
                                  {{ photo.author }}
                                </div>
                                <div class="text-truncation one-line">
                                  <v-icon :title="'Incarcata: ' + photo.uploadDate">mdi-update</v-icon>
                                  {{ photo.uploadDate }}
                                </div>
                                <div class="controls">
                                  <v-icon small color="warning" v-if="photo.isBad" title="Poza marcata ca fiind necorespunzatoare">mdi-alert</v-icon>
                                  <v-icon small color="red accent-1" v-if="photo.isRepozare" :title="'Repozare: ' + photo.repozareDate">mdi-alpha-r-circle-outline</v-icon>
                                  <a :href="photo.url" download target="_blank" style="text-decoration: none" @click.stop>
                                    <v-icon small title="Descarca">mdi-download</v-icon>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <viewer v-if="!deleteEnabled" :options="{url: 'data-src', backdrop: 'static'}" style="height: 100%">
                          <div class="file-container" :class="{ 'delete-enabled': deleteEnabled, 'light': light, 'dark': !light }">
                            <template v-for="photo in visiblePhotos">
                              <div class="item" :key="photo.key" :class="photo.classList">
                                <div class="avatar">
                                  <img :src="photo.thumb" :data-src="photo.url" loading="lazy" decoding="async" :alt="photo.alt">
                                </div>
                                <div class="content">
                                  <div class="text-truncation two-line" :title="'Denumire: ' + photo.filename + ', fisier: ' + photo.photo">
                                    {{ photo.filename }}
                                  </div>
                                  <div class="text-truncation one-line">
                                    <v-icon :title="'Incarcata de: ' + photo.author">mdi-camera</v-icon>
                                    {{ photo.author }}
                                  </div>
                                  <div class="text-truncation one-line">
                                    <v-icon :title="'Incarcata: ' + photo.uploadDate">mdi-update</v-icon>
                                    {{ photo.uploadDate }}
                                  </div>
                                  <div class="controls">
                                    <v-icon small color="warning" v-if="photo.isBad" title="Poza marcata ca fiind necorespunzatoare">mdi-alert</v-icon>
                                    <v-icon small color="red accent-1" v-if="photo.isRepozare" :title="'Repozare: ' + photo.repozareDate">mdi-alpha-r-circle-outline</v-icon>
                                    <a :href="photo.url" download target="_blank" style="text-decoration: none" @click.stop>
                                      <v-icon small title="Descarca">mdi-download</v-icon>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </viewer>
                      </template>
                    </template>
                    <template v-if="tab === 'excels'">
                      <div class="file-container" :class="{ 'delete-enabled': deleteEnabled, 'light': light, 'dark': !light }">
                        <template v-for="excel in visibleExcels">
                          <div class="item" :key="excel.key" :class="excel.classList" @click="_cbSelectDeleteExcelProxy(excel.itemId, excel.excel)">
                            <div class="avatar">
                              <v-icon x-large>mdi-file-excel</v-icon>
                            </div>
                            <div class="content">
                              <div class="text-truncation two-line" :title="'Denumire: ' + excel.filename + ', fisier: ' + excel.excel">
                                {{ excel.filename }}
                              </div>
                              <div class="text-truncation one-line">
                                <v-icon :title="'Incarcat de: ' + excel.author">mdi-camera</v-icon>
                                {{ excel.author }}
                              </div>
                              <div class="text-truncation one-line">
                                <v-icon :title="'Incarcat: ' + excel.uploadDate">mdi-update</v-icon>
                                {{ excel.uploadDate }}
                              </div>
                              <div class="controls">
                                <v-icon small color="warning" v-if="excel.isBad" title="Fisier marcat ca fiind necorespunzatar">mdi-alert</v-icon>
                                <a :href="excel.url" download target="_blank" style="text-decoration: none" @click.stop>
                                  <v-icon small title="Descarca">mdi-download</v-icon>
                                </a>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template v-if="tab === 'pdfs'">
                      <div class="file-container" :class="{ 'delete-enabled': deleteEnabled, 'light': light, 'dark': !light }">
                        <template v-for="pdf in visiblePdfs">
                          <div class="item" :key="pdf.key" :class="pdf.classList" @click="_cbSelectDeletePdfProxy(pdf.itemId, pdf.pdf)">
                            <div class="avatar">
                              <v-icon x-large>mdi-file-pdf-box</v-icon>
                            </div>
                            <div class="content">
                              <div class="text-truncation two-line" :title="'Denumire: ' + pdf.filename + ', fisier: ' + pdf.pdf">
                                {{ pdf.filename }}
                              </div>
                              <div class="text-truncation one-line">
                                <v-icon :title="'Incarcat de: ' + pdf.author">mdi-camera</v-icon>
                                {{ pdf.author }}
                              </div>
                              <div class="text-truncation one-line">
                                <v-icon :title="'Incarcat: ' + pdf.uploadDate">mdi-update</v-icon>
                                {{ pdf.uploadDate }}
                              </div>
                              <div class="controls">
                                <v-icon small color="warning" v-if="pdf.isBad" title="Fisier marcat ca fiind necorespunzatar">mdi-alert</v-icon>
                                <a :href="pdf.url" download target="_blank" style="text-decoration: none" @click.stop>
                                  <v-icon small title="Descarca">mdi-download</v-icon>
                                </a>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </template>
              <template slot="paneR" v-if="showPreview">
                <v-card flat class="ma-0 pa-0" style="display: flex; flex-direction: column; height: 100%">
                  <template v-if="!showEdit">
                    <v-card-title class="ma-0 pa-0">
                      <v-toolbar dense flat>

                        <v-toolbar-title>Preview</v-toolbar-title>

                        <!-- <v-divider vertical class="mx-2"></v-divider> -->

                        <template v-if="selectedPhoto && tab === 'photos'">
                          <v-btn icon @click="zoom(1)" key="zoomin">
                            <v-icon :color="onColor">mdi-plus</v-icon>
                          </v-btn>
                          <v-btn icon @click="zoom(-1)" key="zoomout">
                            <v-icon :color="onColor">mdi-minus</v-icon>
                          </v-btn>
                          <span class="caption" key="explanation"> (also ctrl + scroll)</span>
                          <v-btn icon @click="savePhoto" key="save">
                            <v-icon :color="onColor">mdi-content-save</v-icon>
                          </v-btn>
                        </template>
                        <template v-if="tab === 'excels'">
                          <v-btn-toggle v-model="xlsxViewer" >
                            <v-btn flat :color="xlsxViewer === 0 ? onColor : offColor">
                              <v-icon>mdi-microsoft</v-icon>
                            </v-btn>
                            <v-btn flat :color="xlsxViewer === 1 ? onColor : offColor">
                              <v-icon>mdi-google</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </template>
                      </v-toolbar>
                    </v-card-title>
                    <v-card-text class="pa-0" style="overflow-x: auto; height: 100%; width: 100%">
                      <dir id="editor" style="height: 100%; overflow-x: auto" ref="editor" @wheel.ctrl.prevent="zoom($event.deltaY * -1)" v-if="tab === 'photos'"></dir>
                      <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="95%" v-if="tab === 'pdfs'"></iframe>
                      <embed :src="`https://docs.google.com/gview?url=${selectedExcel && selectedExcel.excel}&embedded=true`" width="100%" height="100%" v-if="tab === 'excels' && xlsxViewer === 1">
                      <embed :src="`http://view.officeapps.live.com/op/view.aspx?src=${selectedExcel && selectedExcel.excel}`" width="100%" height="100%" v-if="tab === 'excels' && xlsxViewer === 0">
                    </v-card-text>
                  </template>
                  <template v-else>
                    <v-card-text class="pa-0" style="overflow-x: auto; height: 100%; width: 100%; position: relative" v-if="entityDetailsId">
                      <entity-details :entity="entityDetailsId"></entity-details>
                    </v-card-text>
                  </template>
                </v-card>
              </template>
            </split-pane>
          </template>
        </split-pane>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" persistent max-width="90vw">
      <v-card flat>
        <v-card-title>Incarcare XLSX cu simboluri</v-card-title>
        <v-card-text>
          <v-alert type="info" outline :value="true">
            Din fisierul xlsx se ignora primul rand (headere). Datele incep sa fie citite de pe randul 2.
            Se filtreaza toate randurile care nu au nimic pe prima coloana. Mai jos un exemplu de structura a fisierului xlsx.
            <v-img src="sample.xlsx.png" max-height="100px" contain />
          </v-alert>
          <v-text-field
            v-model="label"
            label="Eticheta"
            hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate"
            persistent-hint
            class="mt-5">
          </v-text-field>
          <form ref="form" class="mt-5">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading">Renunta</v-btn>
          <v-btn flat :color="onColor" @click="filesAdded" :loading="uploading" :disabled="uploading">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" persistent max-width="90vw" scrollable>
      <v-card flat>
        <v-card-title>Adaugare simbol</v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="addFormValid" lazy-validation>
            <template v-for="field in fields">
              <template v-if="getType(field.value)">
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'eticheta'"
                  :items="labelsText"
                  label="Eticheta"
                  :key="field.value"
                  :menu-props="{transition: false}"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>

                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'zona'"
                  :items="zonesText"
                  label="Zona"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :menu-props="{transition: false}"
                  :rules="getRules(field.value)">
                </v-select>

                <v-text-field
                  class="my-3"
                  v-if="getType(field.value) === 'text'"
                  :key="field.value"
                  :type="getType(field.value)"
                  v-model="newEntity[field.value]"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  validate-on-blur
                  solo
                  flat>
                </v-text-field>

                <div style="width: 100%; height: 50vh" v-if="getType(field.value) === 'map'" :key="field.value">
                  <GmapMap
                    :center="mapCenter"
                    :zoom="13"
                    :style="{ width: '100%', height: '100%' }"
                    ref="map">

                    <GmapMarker
                      :position="mapCenter"
                      :draggable="true"
                      @dragend="_cbDragEnd" />

                  </GmapMap>
                </div>
              </template>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddDialog(0)">Renunta</v-btn>
          <v-btn flat :color="onColor" @click="closeAddDialog(1)">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- filters dialog -->
    <v-dialog v-model="filtersDialog" persistent max-width="500px" :transition="false" no-click-animation hide-overlay scrollable>
      <v-card flat height="75vh">
        <v-card-title>
          <h1 class="headline">
            Filtrare simboluri
          </h1>
        </v-card-title>
        <v-card-text ref="filtersContainer">
          <v-alert type="info" outline :value="true" ref="scrollTargetTop">
            Filtrele aplicate afecteaza atat informatiile din lista de simboluri cat si colectia de elemente de pe harta.
          </v-alert>

          <v-container fluid grid-list-md class="pa-0">
            <v-layout row>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    Filtre generale
                  </v-card-title>
                  <v-card-text>
                    <!-- eticheta -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogLabels"
                          :items="labelsText"
                          label="Eticheta"
                          clearable
                          prepend-icon="mdi-label"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- zona -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogZones"
                          :items="zonesText"
                          label="Zona"
                          clearable
                          prepend-icon="mdi-vector-polygon"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- interval -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-menu
                            v-model="filtersDialogStartDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogStartDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogStartDate = null"
                                label="Data inceput"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogStartDate"
                              @change="filtersDialogStartDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <v-menu
                            v-model="filtersDialogEndDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogEndDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogEndDate = null"
                                label="Data sfarsit"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogEndDate"
                              @change="filtersDialogEndDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- user -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-select
                            v-model="filtersDialogUsers"
                            :items="usersList"
                            :menu-props="{ maxHeight: '400' }"
                            label="Filtru utilizator(i) (ultima persoana care a intervenit pe detaliile entitatii)"
                            multiple
                            clearable
                            chips
                            prepend-icon="mdi-account"
                            :color="onColor">
                            <template v-slot:selection="{ item }">
                              <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </template>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model.number="filtersDialogPerPage"
                          hide-details
                          type="number"
                          min="1"
                          :color="onColor"
                          flat
                          prepend-icon="mdi-pound"
                          label="Simboluri pe pagina">
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs8>
                        <v-select
                          v-model="filtersDialogSortField"
                          :items="sortList"
                          label="Camp sortare rezultate"
                          chips
                          prepend-icon="mdi-account"
                          :color="onColor">
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs4 style="display: flex; align-items: center">
                        <v-btn-toggle mandatory v-model="filtersDialogSortOrder" class="transparent">
                          <v-btn flat :value="1">
                            <v-icon :color="filtersDialogSortOrder === 1 ? onColor : offColor">mdi-arrow-up</v-icon>
                          </v-btn>
                          <v-btn flat :value="-1">
                            <v-icon :color="filtersDialogSortOrder === -1 ? onColor : offColor">mdi-arrow-down</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- done, edited, photos, repozare, myEntities, pdfs, excels -->

            <template v-for="(filterSet, index) in filtersDialogItems">
              <v-layout row :key="index">
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <span>Set filtre {{  index + 1 }}</span>
                      <v-spacer></v-spacer>
                      <v-btn icon small @click="removeFilterSet(index)">
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-list two-line>
                        <template v-for="(value, filter) in filterSet">
                          <v-list-tile :key="filter" @click="toggleFilter(index, filter)">
                            <v-list-tile-avatar>
                              <v-icon>
                                {{filterIcons[filter][null]}}
                              </v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ filterLabels[filter] }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                <v-chip small outline label :color="light ? filterColors.light[value] : filterColors.dark[value]">
                                  {{filterText[filter][value]}}
                                </v-chip>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon left :color="light ? filterColors.light[value] : filterColors.dark[value]" v-if="value !== null">
                                {{filterIcons[filter][value]}}
                              </v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
            <v-layout>
              <v-flex xs12  class="d-flex">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="addFilterSet">
                  <v-icon left>mdi-plus</v-icon>
                  Adauga set
                </v-btn>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-container>
          <p ref="scrollTargetBottom"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeFiltersDialog">Renunta</v-btn>
          <v-btn :color="onColor" flat @click="applyFilters">Aplica</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloadDialog" persistent max-width="90vw" scrollable>
      <v-card flat max-height="75vh">
        <v-card-title>
          <h1 class="headline">
            Meniu descarcare <span class="primary--text">conform filtrelor</span>
          </h1>
        </v-card-title>
        <v-card-text>
          <v-card class="mb-2">
            <v-card-title class="title">
              Export rapoarte xlsx
            </v-card-title>
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Pagina curenta</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Simboluri
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadRaportXLSX(false)" :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Autor poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon @click="downloadRaportAutor(false)" :color="onColor" flat :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze duplicat
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon @click="downloadRaportDuplicat (false)" :color="onColor" flat :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Toate paginile</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Simboluri
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon @click="downloadRaportXLSX(true)" :color="onColor" flat :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Autor poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon @click="downloadRaportAutor(true)" :color="onColor" flat :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze duplicat
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon @click="downloadRaportDuplicat (true)" :color="onColor" flat :disabled="downloading">
                          <v-icon>mdi-file-download</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card class="mb-2">
            <v-card-title class="title">
              Export fisiere &nbsp; <span class="primary--text">simboluri selectate</span>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Grupate pe foldere dupa adresa</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('photos', true, 'selected')" :disabled="!visibleCount['photos'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('excels', true, 'selected')" :disabled="!visibleCount['excels'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('pdfs', true, 'selected')" :disabled="!visibleCount['pdfs'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Negrupate pe foldere</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles(tab, false, 'selected')" :disabled="!visibleCount['photos'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('excels', false, 'selected')" :disabled="!visibleCount['excels'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('pdfs', false, 'selected')" :disabled="!visibleCount['pdfs'] || !selectedItems.length || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card class="mb-2">
            <v-card-title class="title">
              Export fisiere &nbsp; <span class="primary--text">pagina curenta</span>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Grupate pe foldere dupa adresa</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('photos', true, 'page')" :disabled="!visibleCount['photos'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('excels', true, 'page')" :disabled="!visibleCount['excels'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('pdfs', true, 'page')" :disabled="!visibleCount['pdfs'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Negrupate pe foldere</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles(tab, false, 'page')" :disabled="!visibleCount['photos'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('excels', false, 'page')" :disabled="!visibleCount['excels'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('pdfs', false, 'page')" :disabled="!visibleCount['pdfs'] || downloading">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card class="mb-2">
            <v-card-title class="title">
              Export fisiere &nbsp; <span class="primary--text">toate paginile</span>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Grupate pe foldere dupa adresa</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('photos', true, 'all')" :disabled="!visibleCount['photos']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('excels', true, 'all')" :disabled="!visibleCount['excels']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon flat :color="onColor" @click="downloadFiles('pdfs', true, 'all')" :disabled="!visibleCount['pdfs']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md6>
                  <v-list>
                    <v-subheader>
                      <span class="primary--text">Negrupate pe foldere</span>
                    </v-subheader>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Poze
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles(tab, false, 'all')" :disabled="!visibleCount['photos']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-excel</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Excel
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('excels', false, 'all')" :disabled="!visibleCount['excels']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Pdf
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon :color="onColor" flat @click="downloadFiles('pdfs', false, 'all')" :disabled="!visibleCount['pdfs']">
                          <v-icon>mdi-package-down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-progress-linear :indeterminate="downloadStats.size === 0" height="50" auto-height :value="downloadStats.progress" v-if="downloadStats.downloading">
            <div class="d-flex align-stretch justify-center px-2" style="height: 100%; flex-direction: column">
              <div class="d-flex align-center justify-center">
                <span class="text-xs-center">
                  <v-icon small>
                    mdi-download
                  </v-icon>
                  {{ downloadStats.amountText }} / {{ downloadStats.sizeText }}
                </span>
                <span class="text-xs-center">
                  <v-icon small>
                    mdi-speedometer
                  </v-icon>
                  {{ downloadStats.speed}}
                </span>
              </div>
              <div class="d-flex align-center" style="justify-content: space-between">
                <span class="text-xs-center">
                  <v-icon small>
                    mdi-image
                  </v-icon>
                  {{ downloadStats.count }}
                </span>
                <span class="text-xs-center">
                  <v-icon small>
                    mdi-clock
                  </v-icon>
                  {{ downloadStats.elapsed}}
                  /
                  {{ downloadStats.remaining}}
                  s
                </span>
              </div>
            </div>
          </v-progress-linear>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDownloadDialog" class="ml-4">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settingsDialog" persistent max-width="90vw" scrollable>
      <v-card flat max-height="75vh">
        <v-card-title>
          <h1 class="headline">
            Meniu setari
          </h1>
        </v-card-title>
        <v-card-text>
          <v-card class="mb-2">
            <v-card-title class="title">
              Stocare
            </v-card-title>
            <v-card-text>
              <v-progress-linear height="64" :color="light ? '#d8d8d8' : '#383838'" :value="+info.usedPercentage" style="text-align: center; align-self: center">
                <div style="display: flex; align-items: center; justify-content: space-around; height: 100%">
                  <v-icon small :color="onColor">mdi-server-network</v-icon>
                  {{ info.freeGb }}B liberi ({{ info.freePercentage }}%) din {{ info.totalGb }}B
                  <span>
                    <v-icon small :color="tab === 'photos' ? onColor : offColor">mdi-image</v-icon>
                    {{ info.photos }}B
                    <v-icon small :color="tab === 'pdfs' ? onColor : offColor">mdi-file-pdf-box</v-icon>
                    {{ info.pdfs }}B
                    <v-icon small :color="tab === 'excels' ? onColor : offColor">mdi-file-excel</v-icon>
                    {{ info.excels }}B
                  </span>
                  <v-icon small @click="refreshInfo">mdi-refresh</v-icon>
                </div>
              </v-progress-linear>
            </v-card-text>
          </v-card>

          <v-card class="mb-2">
            <v-card-title class="title">
              Simboluri
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <!-- <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Cautare</span>
                  </v-subheader>
                  <v-text-field
                    class="ml-4"
                    placeholder="Cautare"
                    clearable
                    hint="dupa id, adresa, observatii"
                    persistent-hint
                    append-icon="mdi-magnify"
                    :loading="loading"
                    @click:append="_cbSearch"
                    @keydown.enter="_cbSearch"
                    :suffix="String(total)"
                    v-model="searchTerm">
                  </v-text-field>
                </v-flex> -->
                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Mod afisare</span>
                  </v-subheader>
                  <v-btn :value="'gallery'" @click="entityDisplayMode = 'gallery'" flat>
                    <v-icon left :color="entityDisplayMode === 'gallery' ? onColor : offColor">mdi-dots-grid</v-icon>
                    Galerie
                  </v-btn>
                  <v-btn :value="'map'" @click="entityDisplayMode = 'map'" flat>
                    <v-icon left :color="entityDisplayMode === 'map' ? onColor : offColor">mdi-map</v-icon>
                    Harta
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Stergere</span>
                  </v-subheader>
                  <v-btn flat @click.stop.prevent="_cbToggleDeleteMode('symbol')" :title="deleteSymbolsEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                    <v-icon left :color="deleteSymbolsEnabled ? 'error' : offColor">mdi-delete-circle</v-icon>
                    {{deleteSymbolsEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'}}
                  </v-btn>
                  <v-btn flat @click.stop.prevent="_cbConfirmDeleteSymbolsBatch" v-if="deleteSymbolsEnabled" title="Sterge simbolurile de pe pagina, conform filtrelor">
                    <v-icon color="error" left>mdi-bomb</v-icon>
                    Sterge simbolurile de pe pagina, conform filtrelor ({{items.length}})
                  </v-btn>

                  <v-btn flat @click.stop.prevent="_cbConfirmDeleteSymbols" v-if="deleteSymbolsEnabled && toDeleteSymbols.length" title="Sterge simbolurile selectate">
                    <v-icon left color="error">mdi-check-circle</v-icon>
                    Sterge simbolurile selectate ({{toDeleteSymbols.length}})
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card>
            <v-card-title class="title">
              Galerie
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Mod afisare</span>
                  </v-subheader>

                  <v-btn flat @click="togglePreview($event, true, 'edit')" :value="true">
                    <v-icon left :color="showPreview && showEdit ? onColor : offColor">mdi-file-document-edit</v-icon>
                    Editare fisa simbol
                  </v-btn>
                  <v-btn flat @click="togglePreview($event, true)" :value="true">
                    <v-icon left :color="showPreview && !showEdit ? onColor : offColor">
                      {{ tab === 'photos' ? 'mdi-image-edit' : 'mdi-file-document' }}
                    </v-icon>
                    Previzualizare fisiere simbol
                  </v-btn>
                  <v-btn flat @click="togglePreview($event, false)" :value="false">
                    <v-icon left :color="!showPreview ? onColor : offColor">mdi-eye</v-icon>
                    Doar fisiere
                  </v-btn>
                </v-flex>

                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Tip informatii</span>
                  </v-subheader>

                  <v-btn flat @click="setTab('photos')" value="photos">
                    <v-icon left :color="tab === 'photos' ? onColor : offColor">mdi-camera</v-icon>
                    Poze
                  </v-btn>
                  <v-btn flat @click="setTab('pdfs')" value="pdfs">
                    <v-icon left :color="tab === 'pdfs' ? onColor : offColor">mdi-file-pdf-box</v-icon>
                    Pdf
                  </v-btn>
                  <v-btn flat @click="setTab('excels')" value="excels">
                    <v-icon left :color="tab === 'excels' ? onColor : offColor">mdi-file-excel</v-icon>
                    Excel
                  </v-btn>
                </v-flex>

                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Filtre</span>
                  </v-subheader>
                    <v-list dense v-if="tab === 'photos'">
                      <v-subheader>Filtrare poze</v-subheader>
                      <v-list-tile>
                        <v-list-tile-avatar>
                          <v-icon>
                            mdi-filter-off
                          </v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="mr-4">
                            Toate pozele
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-switch v-model="tipPozeToate" :color="onColor"></v-switch>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipPoze1">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipPoze1" :value="tip.value" :color="onColor"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipPoze2">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipPoze2" :value="tip.value" :color="tip.color"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </v-list>

                    <v-list dense v-if="tab === 'pdfs'">
                      <v-subheader>Filtrare pdf-uri</v-subheader>
                      <v-list-tile>
                        <v-list-tile-avatar>
                          <v-icon>
                            mdi-filter-off
                          </v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="mr-4">
                            Toate pdf-urile
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-switch v-model="tipPdfsToate" :color="onColor"></v-switch>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipPdfs1">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipPdfs1" :value="tip.value" :color="onColor"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipPdfs2">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipPdfs2" :value="tip.value" :color="tip.color"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </v-list>

                    <v-list dense v-if="tab === 'excels'">
                      <v-subheader>Filtrare excel-uri</v-subheader>
                      <v-list-tile>
                        <v-list-tile-avatar>
                          <v-icon>
                            mdi-filter-off
                          </v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="mr-4">
                            Toate excel-urile
                          </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-switch v-model="tipExcelsToate" :color="onColor"></v-switch>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipExcels1">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipExcels1" :value="tip.value" :color="onColor"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                      <v-divider></v-divider>
                      <template v-for="tip in availableTipExcels2">
                        <v-list-tile :key="tip.value">
                          <v-list-tile-avatar>
                            <v-icon :color="tip.color">
                              {{ tip.icon }}
                            </v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="mr-4">
                              {{ tip.title }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-switch v-model="tipExcels2" :value="tip.value" :color="tip.color"></v-switch>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </v-list>
                </v-flex>

                <v-flex xs12 class="my-2">
                  <v-subheader>
                    <span class="primary--text">Stergere</span>
                  </v-subheader>

                  <v-btn flat @click.stop.prevent="_cbToggleDeleteMode('photo')" :title="deleteEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'">
                    <v-icon left :color="deleteEnabled ? 'error' : offColor">mdi-delete-circle</v-icon>
                    {{deleteEnabled ? 'Iesi din modul de stergere' : 'Activeaza modul de stergere'}}
                  </v-btn>
                  <v-btn flat @click.stop.prevent="_cbConfirmDelete" v-if="deleteEnabled && toDelete.length" title="Sterge pozele selectate">
                    <v-icon left color="error">mdi-check-circle</v-icon>
                    Sterge pozele selectate ({{toDelete.length}})
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="settingsDialog = false">Renunta</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="alertDialog.dialog" persistent max-width="500px">
      <v-card flat max-height="75vh">
        <v-card-title>
          <h1 class="headline">
            {{ alertDialog.title }}
          </h1>
        </v-card-title>
        <v-card-text>
          <v-alert :type="alertDialog.messageType" :value="true" outline>
            {{ alertDialog.text }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAlertDialog">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="downloadStats.snack"
      :timeout="0"
      multi-line
      bottom>
      <v-progress-linear :indeterminate="downloadStats.size === 0" height="50" auto-height :value="downloadStats.progress">
        <div class="d-flex align-stretch justify-center px-2" style="height: 100%; flex-direction: column">
          <div class="d-flex align-center justify-center">
            <span class="text-xs-center">
              <v-icon small>
                mdi-download
              </v-icon>
              {{ downloadStats.amountText }} / {{ downloadStats.sizeText }}
            </span>
            <span class="text-xs-center">
              <v-icon small>
                mdi-speedometer
              </v-icon>
              {{ downloadStats.speed}}
            </span>
          </div>
          <div class="d-flex align-center" style="justify-content: space-between">
            <span class="text-xs-center">
              <v-icon small>
                mdi-image
              </v-icon>
              {{ downloadStats.count }}
            </span>
            <span class="text-xs-center">
              <v-icon small>
                mdi-clock
              </v-icon>
              {{ downloadStats.elapsed}}
              /
              {{ downloadStats.remaining}}
              s
            </span>
          </div>
        </div>
      </v-progress-linear>
      <!-- <v-btn
        color="pink"
        flat
        @click="downloadStats.snack = false">
        Close
      </v-btn> -->
    </v-snackbar>
  </v-container>
</template>

<script>
import Details from '@/views/Details'
import Map from '@/views/Map'
import 'viewerjs/dist/viewer.css'
import { component as Viewer } from 'v-viewer'
// Bancul cu iepurasul care vrea sa faca clatite
import debounce from 'lodash.debounce'

import prettyBytes from 'pretty-bytes'

// import streamSaver from 'streamsaver'

import splitPane from 'vue-splitpane'

import 'tui-image-editor/dist/tui-image-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'
import 'tui-image-editor/dist/svg/icon-a.svg'
import 'tui-image-editor/dist/svg/icon-b.svg'
import 'tui-image-editor/dist/svg/icon-c.svg'
import 'tui-image-editor/dist/svg/icon-d.svg'

import { GoogleMapsOverlay as DeckOverlay } from '@deck.gl/google-maps'
import { GeoJsonLayer } from '@deck.gl/layers'

// streamSaver.mitm = 'https://amccrs-evr.verdedata.ro/mitm.html'

const ImageEditor = require('tui-image-editor')

export default {
  name: 'dasboard',
  components: {
    'split-pane': splitPane,
    Viewer,
    'entity-details': Details,
    'entity-map': Map
  },
  data: () => ({
    alertDialog: {
      dialog: false,
      title: '',
      messageType: 'info',
      text: ''
    },
    downloadDialog: false,
    settingsDialog: false,
    alphaForGl: 100,
    oldHorizontalPaneSize: 50,
    oldVerticalPaneSize: 50,
    cameraPic: '/img/camera-square-48.png',
    addFormValid: true,
    addDialog: false,
    newEntity: {
      id_scara: null,
      eticheta: null,
      zona: null,
      centru_geometric: {
        lat: 44.443296,
        lng: 26.096505
      }
    },
    mapCenter: {
      lat: 44.443296,
      lng: 26.096505
    },
    availableTipPoze1: Object.freeze([
      {
        value: 'obiectiv',
        title: 'Obiectiv',
        icon: 'mdi-domain',
        color: 'default'
      },
      {
        value: 'lift1',
        title: 'Lift1',
        icon: 'mdi-elevator-passenger',
        color: 'default'
      },
      {
        value: 'lift2',
        title: 'Lift2',
        icon: 'mdi-elevator-passenger',
        color: 'default'
      },
      {
        value: 'lift3',
        title: 'Lift3',
        icon: 'mdi-elevator-passenger',
        color: 'default'
      },
      {
        value: 'lift4',
        title: 'Lift4',
        icon: 'mdi-elevator-passenger',
        color: 'default'
      }
    ]),
    availableTipPoze2: Object.freeze([
      {
        value: 'repozare',
        title: 'Repozare',
        icon: 'mdi-alpha-r-circle-outline',
        color: 'red accent-1'
      },
      {
        value: 'badphoto',
        title: 'Necorespunzatoare',
        icon: 'mdi-alert',
        color: 'warning'
      }
    ]),
    tipPozeToate: true,
    tipPoze1: [],
    tipPoze2: [],

    availableTipExcels1: Object.freeze([
      {
        value: 'obiectiv',
        title: 'Obiectiv',
        icon: 'mdi-domain',
        color: 'primary'
      }
    ]),
    availableTipExcels2: Object.freeze([
      {
        value: 'badexcel',
        title: 'Necorespunzatoare',
        icon: 'mdi-alert',
        color: 'warning'
      }
    ]),
    tipExcelsToate: true,
    tipExcels1: [],
    tipExcels2: [],

    availableTipPdfs1: Object.freeze([
      {
        value: 'obiectiv',
        title: 'Obiectiv',
        icon: 'mdi-domain',
        color: 'primary'
      }
    ]),
    availableTipPdfs2: Object.freeze([
      {
        value: 'badpdf',
        title: 'Necorespunzatoare',
        icon: 'mdi-alert',
        color: 'warning'
      }
    ]),
    tipPdfsToate: true,
    tipPdfs1: [],
    tipPdfs2: [],

    search: '',
    selectedItems: [],
    selectedPhoto: null,
    selectedPdf: null,
    selectedExcel: null,
    editor: null,
    zoomSizes: { width: 0, height: 0 },
    toDelete: [],
    toDeleteSymbols: [],
    deleteEnabled: false,
    deleteSymbolsEnabled: false,
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    zonesDialog: false,
    downloading: false,
    // tab: 'photos',
    pdfFrameTitle: '',
    pdfFrameSrc: '',
    data_inceput_menu: false,
    data_sfarsit_menu: false,

    fields: [ // eticheta, id_scara, adresa, observatii_scara, centru_geometric
      {
        value: 'eticheta',
        label: 'ETICHETA'
      },
      {
        value: 'zona',
        label: 'ZONA'
      },
      {
        value: 'id_scara',
        label: 'ID SCARA'
      },
      {
        value: 'centru_geometric',
        label: 'CENTRU GEOMETRIC'
      }
    ],

    xlsxViewer: 0,

    filtersDialog: false,
    filtersDialogItems: [],
    filtersDialogLabels: [],
    filtersDialogZones: [],

    filtersDialogStartDateMenu: false,
    filtersDialogStartDate: null,
    filtersDialogEndDateMenu: false,
    filtersDialogEndDate: null,

    filtersDialogUsers: [],
    filtersDialogPerPage: 10,
    filtersDialogSortField: null,
    filtersDialogSortOrder: 1,

    rotab: Object.freeze({
      photos: 'poze',
      excels: 'excel',
      pdfs: 'pdf'
    }),

    entityDetailsId: null,
    enityDetailsTitle: null,

    downloadStats: {
      snack: false,
      amount: 0,
      amountText: 0,
      count: 0,
      size: 0,
      sizeText: 0,
      progress: 0,
      elapsed: 0,
      speed: 0,
      remaining: 0,
      downloading: false
    }
  }),
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '-'
    }
  },
  computed: {
    searchVisible: {
      get () {
        return this.$store.getters.searchVisible
      },
      set (value) {
        this.$store.commit('setSearchVisible', value)
      }
    },
    visiblePhotos () {
      if (this.tab === 'photos') {
        if (this.tipPoze1.length || this.tipPoze2.length || this.tipPozeToate) {
          let items = []
          if (this.selectedItems.length) {
            items = this.selectedItems
          } else {
            items = this.items
          }

          return items.reduce((photosAcc, item) => {
            const photos = item.photos.reduce((visibleAcc, photo, index) => {
              const isBad = photo.includes('badphoto')
              const isRepozare = photo.includes('repozare')
              const isSelected = !!(this.selectedPhoto && this.selectedPhoto.photo === photo) || this.toDelete.includes(photo)

              let visiblePhoto1
              let visiblePhoto2

              if (this.tipPozeToate) {
                visiblePhoto1 = true
                visiblePhoto2 = true
              } else {
                visiblePhoto1 = this.tipPoze1.findIndex(tip => photo.includes(tip)) > -1
                visiblePhoto2 = true

                if (this.tipPoze2.length === 2) visiblePhoto2 = isBad && isRepozare
                else if (!this.tipPoze2.length) visiblePhoto2 = !isBad && !isRepozare
                else if (this.tipPoze2.includes('badphoto')) visiblePhoto2 = isBad && !isRepozare
                else visiblePhoto2 = !isBad && isRepozare
              }

              if (visiblePhoto1 && visiblePhoto2) {
                const parts = photo.split('_')
                const dates = this.getDates(photo)
                const filename = `${item.id_scara} ${parts[1]} ${String(index + 1).padStart(3, '0')}`
                const author = this.usersDict[parts[2]] || 'Anonim'

                visibleAcc.push({
                  itemId: item._id,
                  key: `${item._id}_${photo}`,
                  author,
                  thumb: this.serverURL + photo.replace('photos', 'thumbs'),
                  url: this.serverURL + photo,
                  isBad,
                  isRepozare,
                  uploadDate: dates.upload,
                  repozareDate: dates.repozare,
                  photo,
                  filename,
                  classList: {
                    'selected': isSelected,
                    'to-delete': this.toDelete.includes(photo),
                    'blue-grey--text': !isSelected && this.light,
                    'grey--text text--lighten-2': !isSelected && !this.light
                  },
                  alt: `#${filename} 📷${author} 📅${dates.upload} ${isRepozare ? 'Ⓡ ' + dates.repozare : ''} ${isBad ? '⚠ necorespunzatoare' : ''} path: ${photo}`
                })
              }

              return visibleAcc
            }, [])

            return photosAcc.concat(photos)
          }, [])
        } else {
          return []
        }
      } else {
        return []
      }
    },
    visiblePdfs () {
      if (this.tab === 'pdfs') {
        if (this.tipPdfs1.length || this.tipPdfs2.length || this.tipPdfsToate) {
          let items = []
          if (this.selectedItems.length) {
            items = this.selectedItems
          } else {
            items = this.items
          }

          return items.reduce((pdfsAcc, item) => {
            const pdfs = item.pdfs.reduce((visibleAcc, pdf, index) => {
              const isBad = pdf.includes('badpdf')
              const isSelected = !!(this.selectedPdf && this.selectedPdf.pdf === pdf) || this.toDelete.includes(pdf)
              const dates = this.getDates(pdf)

              let visiblePdf1
              let visiblePdf2

              if (this.tipPdfsToate) {
                visiblePdf1 = true
                visiblePdf2 = true
              } else {
                visiblePdf1 = this.tipPdfs1.findIndex(tip => pdf.includes(tip)) > -1
                visiblePdf2 = true

                if (this.tipPdfs2.length === 1) visiblePdf2 = isBad
                else if (this.tipPdfs2.length === 0) visiblePdf2 = !isBad
              }

              if (visiblePdf1 && visiblePdf2) {
                const parts = pdf.split('_')
                visibleAcc.push({
                  itemId: item._id,
                  key: `${item._id}_${pdf}`,
                  author: this.usersDict[parts[2]] || 'Anonim',
                  url: this.serverURL + pdf,
                  uploadDate: dates.upload,
                  isBad,
                  pdf,
                  filename: `${item.id_scara} ${parts[1]} ${String(index + 1).padStart(3, '0')}`,
                  classList: {
                    'selected': isSelected,
                    'to-delete': this.toDelete.includes(pdf),
                    'blue-grey--text': !isSelected && this.light,
                    'grey--text text--lighten-2': !isSelected && !this.light
                  }
                })
              }

              return visibleAcc
            }, [])

            return pdfsAcc.concat(pdfs)
          }, [])
        } else {
          return []
        }
      } else {
        return []
      }
    },
    visibleExcels () {
      if (this.tab === 'excels') {
        if (this.tipExcels1.length || this.tipExcels2.length || this.tipExcelsToate) {
          let items = []
          if (this.selectedItems.length) {
            items = this.selectedItems
          } else {
            items = this.items
          }

          return items.reduce((excelsAcc, item) => {
            const excels = item.excels.reduce((visibleAcc, excel, index) => {
              const isBad = excel.includes('badexcel')
              const isSelected = !!(this.selectedExcel && this.selectedExcel.excel === excel) || this.toDelete.includes(excel)
              const dates = this.getDates(excel)

              let visibleExcel1
              let visibleExcel2

              if (this.tipExcelsToate) {
                visibleExcel1 = true
                visibleExcel2 = true
              } else {
                visibleExcel1 = this.tipExcels1.findIndex(tip => excel.includes(tip)) > -1
                visibleExcel2 = true

                if (this.tipExcels2.length === 1) visibleExcel2 = isBad
                else if (this.tipExcels2.length === 0) visibleExcel2 = !isBad
              }

              if (visibleExcel1 && visibleExcel2) {
                const parts = excel.split('_')
                visibleAcc.push({
                  itemId: item._id,
                  key: `${item._id}_${excel}`,
                  author: this.usersDict[parts[2]] || 'Anonim',
                  url: this.serverURL + excel,
                  uploadDate: dates.upload,
                  isBad,
                  excel,
                  filename: `${item.id_scara} ${parts[1]} ${String(index + 1).padStart(3, '0')}`,
                  classList: {
                    'selected': isSelected,
                    'to-delete': this.toDelete.includes(excel),
                    'blue-grey--text': !isSelected && this.light,
                    'grey--text text--lighten-2': !isSelected && !this.light
                  }
                })
              }

              return visibleAcc
            }, [])

            return excelsAcc.concat(excels)
          }, [])
        } else {
          return []
        }
      } else {
        return []
      }
    },

    onColor () {
      return this.$store.getters.onColor
    },
    offColor () {
      return this.$store.getters.offColor
    },
    totalFiltersLength () {
      return this.newFilters.length + (this.selectedLabel.length !== 0) + (this.selectedZona.length !== 0) + (this.dataInceput !== null) + (this.dataSfarsit !== null) + (this.selectedUsernames.length !== 0)
    },
    labelsText () {
      const etichete = this.$store.getters['entities/labels'].map(label => label.label)
      if (!etichete.length) etichete.push('Fara eticheta')
      return etichete
    },
    zonesText () {
      const zone = this.$store.getters['entities/zones'].map(zona => zona.zona)
      if (!zone.length) zone.push('Fara zona')
      return zone
    },
    visibleCount () {
      return {
        photos: this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.photos.length), 0),
        excels: this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.excels ? item.excels.length : 0), 0),
        pdfs: this[this.selectedItems.length ? 'selectedItems' : 'items'].reduce((acc, item) => (acc += item.pdfs ? item.pdfs.length : 0), 0)
      }
    },
    serverURL () {
      return this.$store.getters.serverURL
    },
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters['entities/items']
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    perPage () {
      return this.$store.getters['entities/perPage']
    },
    total () {
      return this.$store.getters['entities/total']
    },
    totalPages () {
      return this.perPage ? Math.ceil(this.total / this.perPage) : 0
    },

    info () {
      return this.$store.getters.info
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    selectedLabel: {
      get () {
        return this.$store.getters['entities/selectedLabel']
      },
      set (value) {
        if (value.includes('Toate')) {
          this.$store.commit('entities/setSelectedLabel', ['Toate'])
        } else {
          this.$store.commit('entities/setSelectedLabel', value)
        }
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    selectedZona: {
      get () {
        return this.$store.getters['entities/selectedZona']
      },
      set (value) {
        if (value.includes('Toate')) {
          this.$store.commit('entities/setSelectedZona', ['Toate'])
        } else {
          this.$store.commit('entities/setSelectedZona', value)
        }
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    token () {
      return this.$store.getters.token
    },

    dataInceput: {
      get () {
        return this.$store.getters['entities/dataInceput']
      },
      set (value) {
        // console.log('set data inceput')
        this.$store.commit('entities/setDataInceput', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },
    dataSfarsit: {
      get () {
        return this.$store.getters['entities/dataSfarsit']
      },
      set (value) {
        // console.log('set data sfarsit')

        this.$store.commit('entities/setDataSfarsit', value)
        this.$store.dispatch('entities/fetchEntities')
      }
    },

    usersList () {
      return this.$store.getters['entities/dbusernames']
    },
    usersDict () {
      return this.$store.getters['entities/usersDict']
    },
    selectedUsernames () {
      return this.$store.getters['entities/selectedUsernames']
    },
    user () {
      return this.$store.getters.user
    },

    tab () {
      return this.$store.getters.tab
    },
    paneVertical () {
      return this.$store.getters.paneVertical
    },
    paneHorizontal () {
      return this.$store.getters.paneHorizontal
    },
    showGallery () {
      return this.$store.getters.showGallery
    },
    showPreview () {
      return this.$store.getters.showPreview
    },
    showEdit () {
      return this.$store.getters.showEdit
    },
    light () {
      return this.$store.getters.light
    },

    geoJsonItems () {
      const json = this.items.map(item => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.centru_geometric.lng, item.centru_geometric.lat]
          },
          properties: {
            done: item.done,
            user: item.user,
            zona: item.zona,
            repozare: item.repozare,
            _id: item._id
          }
        }
      })

      return json
    },

    newFilters () {
      return this.$store.getters['entities/newFilters']
    },

    filtersStateColor () {
      if (this.light) {
        return this.totalFiltersLength ? 'primary' : 'blue-grey'
      } else {
        return this.totalFiltersLength ? 'primary lighten-2' : 'grey lighten-2'
      }
    },

    query () {
      return this.$store.getters['entities/query']
    },

    sort () {
      return this.$store.getters['entities/sort']
    },
    sortList () {
      return this.$store.getters['entities/sortList']
    },

    entityDisplayMode: {
      get () {
        return this.$store.getters['entityDisplayMode']
      },
      set (value) {
        this.$store.commit('setEntityDisplayMode', value)

        if (value === 'map') {
          if (!this.showPreview) {
            this.$store.commit('setPreviewVisibility', true)
          }

          if (!this.showEdit) {
            this.$store.commit('setEditVisibility', true)
          }

          this.paneResize(10, 'vertical')
        } else {
          // this.oldVerticalPaneSize = this.paneVertical < 100 ? this.paneVertical : 50
          // this.paneResize(100, 'vertical')
          this.paneResize(this.oldVerticalPaneSize, 'vertical')
        }
      }
    }
  },
  watch: {
    tab: {
      immediate: true,
      handler: function (val) {
        if (val === 'photos' && this.showGallery && this.showPreview && !this.showEdit) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    showGallery: {
      immediate: true,
      handler: function (val) {
        if (this.tab === 'photos' && val && this.showPreview && !this.showEdit) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    showPreview: {
      immediate: true,
      handler: function (val) {
        if (this.tab === 'photos' && this.showGallery && val && !this.showEdit) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    showEdit: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.paneResize(10, 'vertical')
        } else {
          if (this.showPreview) {
            this.paneResize(this.oldVerticalPaneSize, 'vertical')
          }
        }
        if (this.tab === 'photos' && this.showGallery && !val && this.showPreview) {
          this.$nextTick(() => {
            this.initializeEditor()
          })
        }
      }
    },
    tipPozeToate (value) {
      if (value) {
        this.tipPoze1 = []
        this.tipPoze2 = []
      }
    },
    tipPoze1 (value) {
      if (value.length) this.tipPozeToate = false
    },
    tipPoze2 (value) {
      if (value.length) this.tipPozeToate = false
    },
    tipPdfsToate (value) {
      if (value) {
        this.tipPdfs1 = []
        this.tipPdfs2 = []
      }
    },
    tipPdfs1 (value) {
      if (value.length) this.tipPdfsToate = false
    },
    tipPdfs2 (value) {
      if (value.length) this.tipPdfsToate = false
    },
    tipExcelsToate (value) {
      if (value) {
        this.tipExcels1 = []
        this.tipExcels2 = []
      }
    },
    tipExcels1 (value) {
      if (value.length) this.tipExcelsToate = false
    },
    tipExcels2 (value) {
      if (value.length) this.tipExcelsToate = false
    }
  },
  methods: {
    closeAlertDialog () {
      this.alertDialog.dialog = false
      this.alertDialog.title = null
      this.alertDialog.text = null
      this.alertDialog.messageType = 'info'
    },
    closeDownloadDialog () {
      this.downloadDialog = false
      this.downloadStats.snack = this.downloadStats.downloading === true
    },
    formatLongDateTime (dateString) {
      return new Date(dateString).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    removeFilterSet (index) {
      this.filtersDialogItems.splice(index, 1)
    },

    markerClicked (item) {
      this.$store.dispatch('entities/setActiveEntity', item._id)
      this.entityDetailsId = item._id
      this.enityDetailsTitle = item.id_scara
      this.selectedItems = [item]
    },

    addFilterSet () {
      this.filtersDialogItems.push(JSON.parse(JSON.stringify(this.filtersTemplate)))

      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs.scrollTargetBottom, {
          container: this.$refs.filtersContainer,
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic'
        })
      })
    },

    setFiltersDialogItems () {
      this.filtersDialogItems = JSON.parse(JSON.stringify(this.newFilters))
      this.filtersDialogLabels = JSON.parse(JSON.stringify(this.selectedLabel))
      this.filtersDialogZones = JSON.parse(JSON.stringify(this.selectedZona))

      this.filtersDialogStartDate = JSON.parse(JSON.stringify(this.dataInceput))
      this.filtersDialogEndDate = JSON.parse(JSON.stringify(this.dataSfarsit))

      this.filtersDialogUsers = JSON.parse(JSON.stringify(this.selectedUsernames))

      this.filtersDialogPerPage = JSON.parse(JSON.stringify(this.perPage))

      this.filtersDialogSortField = JSON.parse(JSON.stringify(this.sort.field))
      this.filtersDialogSortOrder = JSON.parse(JSON.stringify(this.sort.order))
    },
    openFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = true
    },
    applyFilters () {
      this.$store.commit('entities/setSelectedLabel', this.filtersDialogLabels)
      this.$store.commit('entities/setSelectedZona', this.filtersDialogZones)

      this.$store.commit('entities/setDataInceput', this.filtersDialogStartDate)
      this.$store.commit('entities/setDataSfarsit', this.filtersDialogEndDate)

      this.$store.commit('entities/setSelectedUsernames', this.filtersDialogUsers)

      if (this.filtersDialogPerPage <= 0) this.filtersDialogPerPage = 10
      this.$store.commit('entities/setPerPage', this.filtersDialogPerPage)

      this.$store.commit('entities/setSort', { field: this.filtersDialogSortField, order: this.filtersDialogSortOrder })

      this.$store.dispatch('entities/applyFilters', this.filtersDialogItems)

      this.closeFiltersDialog()
    },
    closeFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = false
    },
    toggleFilter (index, filter) {
      // values:
      // null = no filter ( or 'all' for myEntities)
      // 1 = filter set to true (or 'mine' for myEntities)
      // -1 = filter set to false (or 'not mine' for myEntities)

      // possible values:
      // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]

      if (this.filtersDialogItems[index][filter] === null) {
        this.filtersDialogItems[index][filter] = 1
      } else if (this.filtersDialogItems[index][filter] === 1) {
        this.filtersDialogItems[index][filter] = -1
      } else if (this.filtersDialogItems[index][filter] === -1 && ['myEntities', 'repozare', 'repozare_done', 'repozare_check'].includes(filter)) {
        this.filtersDialogItems[index][filter] = 0
      } else { // not done
        this.filtersDialogItems[index][filter] = null
      }
    },
    filterColor (index, filter) {
      return this.light ? this.filterColors.light[this.filtersDialogItems[index][filter]] : this.filterColors.dark[this.filtersDialogItems[index][filter]]
    },
    getDates (photo) {
      const uploadDate = this.formatLongDateTime(+photo.split('_')[3].split('.')[0])
      const repozareDate = photo.includes('_repozare_') ? this.formatLongDateTime(+photo.split('_repozare_')[1].split('.')[0]) : 'Nope'

      return {
        upload: uploadDate,
        repozare: repozareDate
      }
    },
    getCircleFillColor (marker) {
      return [255, 255, 255, 255]
    },
    getCircleLineColor (marker) {
      return [0, 0, 0, 255]
    },
    _cbAddEntity () {
      this.addDialog = true
      this.$refs.map[0].$mapPromise.then(() => {
        window.overlay = new DeckOverlay({
          layers: [
            new GeoJsonLayer({
              id: 'markers',
              data: this.geoJsonItems,
              pointType: 'circle',
              // Styles

              pointRadiusUnits: 'meters',
              getPointRadius: 2,
              pointRadiusScale: 1,
              pointRadiusMinPixels: 8,
              pointRadiusMaxPixels: 12,
              pointAntialiasing: true,
              pointBillboard: false,

              filled: true,
              getFillColor: f => this.getCircleFillColor(f.properties),
              getLineColor: f => this.getCircleLineColor(f.properties),
              getLineWidth: 20,
              lineWidthMinPixels: 1,
              lineWidthMaxPixels: 2,
              // Interactive props
              pickable: false,
              autoHighlight: true
            })
          ]
        })

        window.overlay.setMap(this.$refs.map[0].$mapObject)
      })
    },

    downloadRaportDuplicat (all = false) {
      // raport poze duplicate
      this.downloading = true
      fetch(`${this.serverURL}/raport3`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ query: this.query[all ? 'all' : 'page'] })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'Verde-Share_Poze_Identice.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)

          this.alertDialog.title = 'Eroare'
          this.alertDialog.text = 'Ceva nu a functionat...' + (err.message ? ': ' + err.message : '')
          this.alertDialog.messageType = 'error'
          this.alertDialog.dialog = true
        })
    },
    downloadRaportAutor (all = false) {
      // raport autor poze
      this.downloading = true
      fetch(`${this.serverURL}/raport2`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ query: this.query[all ? 'all' : 'page'] })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = 'Verde-Share_Poze_User_size.xlsx'
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)

          this.alertDialog.title = 'Eroare'
          this.alertDialog.text = 'Ceva nu a functionat...' + (err.message ? ': ' + err.message : '')
          this.alertDialog.messageType = 'error'
          this.alertDialog.dialog = true
        })
    },
    downloadRaportXLSX (all = false) {
      // raport xlsx
      this.downloading = true
      fetch(`${this.serverURL}/raport`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ query: this.query[all ? 'all' : 'page'] })
      })
        .then(response => {
          if (!response.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          return response.blob()
        })
        .then(blob => {
          this.downloading = false
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = url
          a.download = `Verde-Share_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.xlsx`
          document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click()
          a.remove() // afterwards we remove the element again
        })
        .catch(err => {
          this.downloading = false
          console.log(err)

          this.alertDialog.title = 'Eroare'
          this.alertDialog.text = 'Ceva nu a functionat...' + (err.message ? ': ' + err.message : '')
          this.alertDialog.messageType = 'error'
          this.alertDialog.dialog = true
        })
    },

    resetLabel () {
      this.selectedLabel = ['Toate']
    },
    resetZona () {
      this.selectedZona = ['Toate']
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    openZonesDialog () {
      this.zonesDialog = true
    },
    closeZonesDialog () {
      this.zonesDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    refreshInfo () {
      this.$store.dispatch('getInfo')
    },
    isToDelete (file) {
      return this.toDelete.includes(file)
    },
    _cbConfirmDeleteSymbolsBatch () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.items.length} simboluri si pozele aferente! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(() => {
          const ids = this.items.map(item => item._id)
          this.$store.dispatch('entities/deleteEntities', ids)
        })
        .catch(() => {})
    },
    _cbConfirmDeleteSymbols () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDeleteSymbols.length} simboluri si pozele aferente! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          this.selectedItems = this.selectedItems.filter(item => !this.toDeleteSymbols.includes(item._id))
          this.$store.dispatch('entities/deleteEntities', this.toDeleteSymbols)
          this.toDeleteSymbols = []
        })
        .catch(() => {})
    },
    _cbSelectDeleteSymbolProxy (item) {
      if (this.deleteSymbolsEnabled) {
        const index = this.toDeleteSymbols.findIndex(simbol => simbol === item._id)
        if (index > -1) this.toDeleteSymbols.splice(index, 1)
        else this.toDeleteSymbols.push(item._id)
      } else {
        this.setSelectedItem(item)
      }
    },
    _cbSelectDeletePhotoProxy (itemId, photo) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === photo)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(photo)
      } else {
        this.setSelectedPhoto(itemId, photo)
      }
    },
    _cbToggleDeleteMode (type) {
      if (type === 'photo') {
        this.deleteEnabled = !this.deleteEnabled
        this.toDelete = []
      } else {
        this.deleteSymbolsEnabled = !this.deleteSymbolsEnabled
        this.toDeleteSymbols = []
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: `Esti pe cale sa stergi ${this.toDelete.length} ${this.tab}! Confirmi stergerea?`
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          switch (this.tab) {
            case 'photos': {
              const photos = this.toDelete.filter(item => item.startsWith('/photos/'))
              this.$store.dispatch('entities/deletePhotos', { entity: this.deleteEntity, photos })
              this.selectedItems.forEach(item => {
                item.photos = item.photos.filter(photo => !this.toDelete.includes(photo))
              })
              break
            }
            case 'pdfs': {
              const pdfs = this.toDelete.filter(item => item.startsWith('/pdfs/'))
              this.$store.dispatch('entities/deletePdfs', { entity: this.deleteEntity, pdfs })
              this.selectedItems.forEach(item => {
                item.pdfs = item.pdfs.filter(pdf => !this.toDelete.includes(pdf))
              })
              break
            }
            case 'excels': {
              const excels = this.toDelete.filter(item => item.startsWith('/excels/'))
              this.$store.dispatch('entities/deleteExcels', { entity: this.deleteEntity, excels })
              this.selectedItems.forEach(item => {
                item.excels = item.excels.filter(excel => !this.toDelete.includes(excel))
              })
              break
            }
          }

          this.toDelete = []
        })
        .catch(() => {})
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    isSelectedItem (item) {
      return !!this.selectedItems.find(sItem => sItem._id === item._id)
    },

    getSrc (marker) {
      if (marker.repozare === 'Da') {
        if (marker.repozare_check === 'Da') return '/svg/repozare_check.png'
        if (marker.repozare_check === 'Nu') return '/svg/repozare.png'
        if (marker.repozare_done === 'Da') return '/svg/repozare_done.png'
        return '/svg/repozare.png'
      }

      if (marker.addedBy) {
        if (marker.done) return '/svg/done_people.png'
        return marker.user ? '/svg/edited_people.png' : '/svg/unedited_people.png'
      } else {
        if (marker.done) return '/svg/done.png'
        return marker.user ? '/svg/edited.png' : '/svg/unedited.png'
      }
    },
    setSelectedItem (item) {
      if (this.isSelectedItem(item)) {
        this.selectedItems = this.selectedItems.filter(sItem => sItem._id !== item._id)

        this.$store.dispatch('entities/setActiveEntity', null)
        this.entityDetailsId = null

        if (this.selectedItems.length) {
          this.$store.dispatch('entities/setActiveEntity', this.selectedItems.at(-1)._id)
          this.entityDetailsId = this.selectedItems.at(-1)._id
          this.enityDetailsTitle = this.selectedItems.at(-1).id_scara
        }
      } else {
        this.selectedItems.push(item)
        this.selectedItems = this.selectedItems.sort((a, b) => a.id_scara.localeCompare(b.id_scara))

        this.$store.dispatch('entities/setActiveEntity', item._id)
        this.entityDetailsId = item._id
        this.enityDetailsTitle = item.id_scara
      }
    },
    setSelectedPhoto (itemId, photo) {
      if (this.selectedPhoto && this.selectedPhoto.photo === photo) {
        this.selectedPhoto = null
        photo = '/img/placeholder.png'
      } else {
        this.selectedPhoto = {
          id: itemId,
          photo
        }
      }

      if (this.showPreview) {
        const canvasSize = this.editor.getCanvasSize()
        const width = this.$refs.editor.scrollWidth
        const height = this.$refs.editor.scrollHeight

        this.editor.loadImageFromURL(this.serverURL + photo, photo).then(result => {
          const { newWidth, newHeight } = result
          const ratio = newWidth / newHeight

          this.editor.ui.resizeEditor({
            imageSize: result,
            uiSize: { width, height }
          })

          if (this.zoomSizes.width) {
            canvasSize.width = this.zoomSizes.width
            canvasSize.height = width / ratio
          } else {
            canvasSize.width = width
            canvasSize.height = width / ratio
          }
          this.editor.resizeCanvasDimension(canvasSize)

          this.zoomSizes = canvasSize
          this.editor.clearRedoStack()
          this.editor.clearUndoStack()
          // w = r * h
          // h = w / r
        })
      }
    },
    clearSelected () {
      this.selectedItems = []
    },
    zoom (dir) {
      const canvasSize = this.zoomSizes
      const ratio = canvasSize.width / canvasSize.height
      const width = canvasSize.width * (dir > 0 ? 1.1 : 0.9)
      if (width > 0) {
        const height = width / ratio
        this.editor.resizeCanvasDimension({ width, height })
        this.zoomSizes = { width, height }
      }
    },
    savePhoto () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Operatie ireversibila. Confirmi operatia?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, anuleaza',
          animation: 'zoom'
        })
        .then(dialog => {
          const options = {
            format: 'jpeg',
            quality: 1
          }
          const newImage = this.editor.toDataURL(options)
          // console.log(newImage)
          this.$store.dispatch('entities/saveEditedPhoto', { ...this.selectedPhoto, newImage, parent: this.selectedPhoto.photo.split('_')[1], user: this.selectedPhoto.photo.split('_')[2] })
            .then(response => {
              this.editor.clearRedoStack()
              this.editor.clearUndoStack()
              const index = this.selectedItems.findIndex(item => item._id === response._id)
              if (index > -1) this.selectedItems.splice(index, 1, response)

              this.selectedPhoto = null
              this.editor.loadImageFromURL(this.serverURL + '/img/placeholder.png', 'photo')

              // console.log('save photo')

              this.$store.dispatch('entities/fetchEntities')
            })
            .catch(err => {
              console.log(err)

              this.alertDialog.title = 'Eroare'
              this.alertDialog.text = 'Ceva nu a functionat la salvarea fisierului...' + (err.message ? ': ' + err.message : '')
              this.alertDialog.messageType = 'error'
              this.alertDialog.dialog = true
            })
        })
        .catch(() => {})
    },
    async downloadFiles (type = 'photos', grouped = true, all = 'selected') {
      let badFiles = false
      try {
        await this.$dialog
          .confirm({
            title: 'Optiune download',
            body: 'Vrei sa descarci si fisierele marcate ca fiind necorespunzatoare?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
        badFiles = true
      } catch (e) {
        badFiles = false
      }

      this.downloading = true
      this.downloadStats.downloading = true

      try {
        // Request a file handle from the user first
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: `AMCCRS-EVR_export_${type}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`,
          types: [{
            description: 'ZIP file',
            accept: { 'application/zip': ['.zip'] }
          }]
        })

        const statsResponse = await fetch(`${this.serverURL}/rest-download-size`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({
            query: this.selectedItems.length ? {
              _id: {
                $in: this.selectedItems.map(item => item._id)
              }
            } : this.query[all === 'all' ? 'all' : 'page'],
            type,
            badFiles,
            grouped
          })
        })

        if (!statsResponse.ok) throw new Error('Server returned an error.')

        const { size, count } = await statsResponse.json()

        this.downloadStats.size = size
        this.downloadStats.sizeText = prettyBytes(size, { locale: 'ro' })
        this.downloadStats.count = count

        // Fetch the file from the server
        const response = await fetch(`${this.serverURL}/rest-download`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({
            query: this.selectedItems.length ? {
              _id: {
                $in: this.selectedItems.map(item => item._id)
              }
            } : this.query[all === 'all' ? 'all' : 'page'],
            type,
            badFiles,
            grouped
          })
        })

        if (!response.ok) throw new Error('Server returned an error.')

        // Create a FileSystemWritableFileStream to write to
        const writableStream = await fileHandle.createWritable()
        const reader = response.body.getReader()
        const writer = writableStream.getWriter()
        const start = performance.now()

        // Use the response body's stream directly
        if (response.body) {
          let totalBytesWritten = 0

          while (true) {
            const { done, value } = await reader.read()
            if (done) break

            await writer.write(value)
            totalBytesWritten += value.length

            // Update progress UI here
            // console.log(`Downloaded ${totalBytesWritten} bytes`)
            this.downloadStats.amountText = prettyBytes(totalBytesWritten, { locale: 'ro' })
            this.downloadStats.progress = (totalBytesWritten / this.downloadStats.size) * 100

            const elapsed = Math.ceil((performance.now() - start) / 1000)
            const speed = totalBytesWritten / elapsed
            const remaining = Math.round((this.downloadStats.size - totalBytesWritten) / speed)

            this.downloadStats.elapsed = elapsed
            this.downloadStats.speed = `${prettyBytes(speed, { locale: 'ro' })}/s`
            this.downloadStats.remaining = remaining
          }

          // Close the streams
          writer.close()

          this.downloading = false
          this.downloadStats.amount = 0
          this.downloadStats.amountText = 0
          this.downloadStats.size = 0
          this.downloadStats.sizeText = 0
          this.downloadStats.progress = 0
          this.downloadStats.count = 0
          this.downloadStats.elapsed = 0
          this.downloadStats.speed = 0
          this.downloadStats.remaining = 0
          this.downloadStats.downloading = false
          this.downloadStats.snack = false

          this.alertDialog.title = 'Info'
          this.alertDialog.text = 'Descarcare finalizata cu succes!'
          this.alertDialog.messageType = 'success'
          this.alertDialog.dialog = true
        } else {
          throw new Error('Failed to get the body stream.')
        }
      } catch (err) {
        this.downloading = false
        this.downloadStats.amount = 0
        this.downloadStats.amountText = 0
        this.downloadStats.size = 0
        this.downloadStats.sizeText = 0
        this.downloadStats.progress = 0
        this.downloadStats.count = 0
        this.downloadStats.elapsed = 0
        this.downloadStats.speed = 0
        this.downloadStats.remaining = 0
        this.downloadStats.downloading = false
        this.downloadStats.snack = false

        this.alertDialog.title = 'Eroare'
        this.alertDialog.text = 'Ceva nu a functionat...' + (err.message ? ': ' + err.message : '')
        this.alertDialog.messageType = 'error'
        this.alertDialog.dialog = true
      }

      /* old streamsaver method

      const fileStream = streamSaver.createWriteStream(`Verde-Share_export_${type}_${new Date().toLocaleString('ro-RO').replace(', ', '_')}.zip`)

      fetch(`${this.serverURL}/rest-download`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({
          query: this.selectedItems.length ? {
            _id: {
              $in: this.selectedItems.map(item => item._id)
            }
          } : this.query[all === 'all' ? 'all' : 'page'],
          type,
          badFiles,
          grouped
        })
      })
        .then(res => {
          this.downloading = false

          if (!res.ok) {
            // alert('Whoops! Server error...')
            throw new Error('Server error...')
          }
          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream)
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => done
            // close the stream so we stop writing
            ? writer.close()
            // Write one chunk, then get the next one
            : writer.write(value).then(pump)
          )

          // Start the reader
          pump().then(() =>
            console.log('Closed the stream, Done writing')
          )
        })
        .catch(err => {
          this.downloading = false
          console.log(err)
          alert('Whoops! Something went wrong...')
        })

      */
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded (e) {
      if (!this.$refs.fileinput.files.length) return
      // this.$store.commit('setLoading', true)

      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(err => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false

            this.alertDialog.title = 'Eroare'
            this.alertDialog.text = 'Ceva nu a functionat...' + (err.message ? ': ' + err.message : '')
            this.alertDialog.messageType = 'error'
            this.alertDialog.dialog = true
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        // this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false

        this.alertDialog.title = 'Eroare'
        this.alertDialog.text = 'Dispozitivul d-voastra nu suporta aceasta functie.' + (err.message ? ': ' + err.message : '')
        this.alertDialog.messageType = 'error'
        this.alertDialog.dialog = true
      }
    },
    setTab (tab) {
      this.toDelete = []

      this.$store.commit('setDashboardTab', tab)
    },

    _cbSelectDeletePdfProxy (itemId, pdf) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === pdf)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(pdf)
      } else {
        this.setSelectedPdf(itemId, pdf)
      }
    },
    setSelectedPdf (itemId, pdf) {
      if (this.selectedPdf && this.selectedPdf.pdf === pdf) {
        this.selectedPdf = null

        this.pdfFrameSrc = null
        this.pdfFrameTitle = null
      } else {
        this.selectedPdf = {
          id: itemId,
          pdf
        }
        this.pdfFrameSrc = this.serverURL + pdf + '?buster=' + new Date().getTime()
        this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      }
    },

    _cbSelectDeleteExcelProxy (itemId, excel) {
      if (this.deleteEnabled) {
        const index = this.toDelete.findIndex(item => item === excel)
        if (index > -1) this.toDelete.splice(index, 1)
        else this.toDelete.push(excel)
      } else {
        this.setSelectedExcel(itemId, excel)
      }
    },
    setSelectedExcel (itemId, excel) {
      if (this.selectedExcel && this.selectedExcel.excel === excel) {
        this.selectedExcel = null
      } else {
        this.selectedExcel = {
          id: itemId,
          excel // : 'https://static.anaf.ro/rapfxb/LOT244/20200131_FXB-EXB-901_TREZ701_4505359_4505359_02_18643433.xlsx?id=' + new Date().getTime()
        }
      }
    },

    resetData (which) {
      this[`data${which}`] = null
    },

    showIfBadPdf (pdf) {
      if (this.tipPdfs.includes('bad pdfs')) {
        return pdf.includes('badpdf')
      } else {
        return !pdf.includes('badpdf')
      }
    },
    showIfBadExcel (excel) {
      if (this.tipExcels.includes('bad excels')) {
        return excel.includes('badexcel')
      } else {
        return !excel.includes('badexcel')
      }
    },

    filterByUsername () {
      this.$store.dispatch('entities/filterByUsername', this.selectedUsernames)
    },

    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        default: return []
      }
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'id_scara': return 'text'
        case 'centru_geometric': return 'map'
        default: return false
      }
    },
    _cbDragEnd: debounce(function ($event) {
      const pos = { lat: $event.latLng.lat(), lng: $event.latLng.lng() }
      this.$set(this.newEntity, 'centru_geometric', pos)
      this.$forceUpdate()
    }, 1000),
    closeAddDialog (mode) {
      if (mode) {
        if (!this.$refs.addForm.validate()) return
        this.addDialog = false
        this.$refs.addForm.resetValidation()

        const obj2save = {}

        Object.keys(this.newEntity).forEach(key => {
          switch (this.getType(key)) {
            case 'map': obj2save[key] = this.newEntity[key] ? { ...this.newEntity[key] } : null; break
            case 'number': obj2save[key] = !isNaN(this.newEntity[key]) ? Number(this.newEntity[key]) : null; break
            default: obj2save[key] = this.newEntity[key] === null ? null : String(this.newEntity[key])
          }

          this.newEntity[key] = null
          // this.newEntity.id_scara = null
        })

        this.newEntity.centru_geometric = { ...this.mapCenter }
        // this.newEntity.regim_inaltime = 'P'

        if (JSON.stringify(this.newEntity) !== JSON.stringify(obj2save)) {
          obj2save.done = false
          if (!this.user.admin) {
            obj2save.user = this.user.username
            obj2save.addedBy = this.user.username
          }

          this.$store.state.services.entities.create(obj2save)
        }
      } else {
        this.addDialog = false
        this.$refs.addForm.resetValidation()
        this.newEntity = {
          eticheta: null,
          zona: null,
          id_scara: null,
          centru_geometric: { ...this.mapCenter }
        }
      }

      if (window.overlay) {
        window.overlay.finalize()
        window.overlay = null
      }
    },
    toggleExcels () {
      this.$store.dispatch('entities/toggleExcels')
    },

    paneResize: debounce(function ($event, direction) {
      this.$store.commit('setDashboardSplitPane', { val: $event, dir: direction })
    }, 1000),

    toggleGallery () {
      if (this.showGallery) {
        this.oldHorizontalPaneSize = this.paneHorizontal < 100 ? this.paneHorizontal : 50
        this.paneResize(100, 'horizontal')
      } else {
        this.paneResize(this.oldHorizontalPaneSize, 'horizontal')
      }

      // if (!this.showGallery && this.tab === 'photos') {
      //   this.$nextTick(() => {
      //     this.initializeEditor()
      //   })
      // }

      this.$store.commit('setGalleryVisibility', !this.showGallery)
    },
    togglePreview ($event, mode = null, edit = null) {
      if (mode === null) {
        if (this.showPreview) {
          this.oldVerticalPaneSize = this.paneVertical < 100 ? this.paneVertical : 50
          this.paneResize(100, 'vertical')

          this.$store.commit('setEditVisibility', false)
        } else {
          this.paneResize(this.oldVerticalPaneSize, 'vertical')
        }
        this.$store.commit('setPreviewVisibility', !this.showPreview)
      } else {
        if (mode && this.showPreview && this.showEdit && !edit) {
          this.$store.commit('setEditVisibility', false)
        }
        if (mode && this.showPreview && !this.showEdit && edit) {
          this.$store.commit('setEditVisibility', true)
          // this.paneResize(0, 'vertical')
        }

        if (mode && !this.showPreview) {
          this.paneResize(this.oldVerticalPaneSize, 'vertical')
          this.$store.commit('setPreviewVisibility', mode)

          if (edit) {
            // if (!this.showEdit) {
            //   this.paneResize(0, 'vertical')
            // }
            this.$store.commit('setEditVisibility', !this.showEdit)
          }
        }
        if (!mode && this.showPreview) {
          this.oldVerticalPaneSize = this.paneVertical < 100 ? this.paneVertical : 50
          this.paneResize(100, 'vertical')
          this.$store.commit('setPreviewVisibility', mode)

          this.$store.commit('setEditVisibility', false)
        }
      }
      // if (!this.showPreview && this.tab === 'photos') {
      //   this.$nextTick(() => {
      //     this.initializeEditor()
      //   })
      // }
    },

    initializeEditor: debounce(function () {
      // console.log('initializing editor')

      if (this.searchTerm) {
        this.search = this.searchTerm
      }

      this.editor = new ImageEditor(document.querySelector('#editor'), {
        includeUI: {
          loadImage: {
            // path: this.serverURL + photo,
            path: this.serverURL + '/img/placeholder.png',
            // path: 'https://www.grouphealth.ca/wp-content/uploads/2018/05/placeholder-image-300x225.png',
            name: 'photo'
          },
          // initMenu: 'filter',
          menuBarPosition: 'bottom'
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500,
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70
        }
      })
    }, 500)
  },
  beforeMount () {
    this.$store.dispatch('entities/fetchUsernames')

    this.filtersTemplate = Object.freeze({
      done: null,
      edited: null,
      photos: null,
      repozare: null,
      repozare_done: null,
      repozare_check: null,
      myEntities: null,
      pdfs: null,
      excels: null
    })

    this.filterLabels = Object.freeze({
      done: 'Finalizare',
      edited: 'Editare',
      photos: 'Poze',
      repozare: 'Repozare',
      repozare_done: 'Repozare incheiata',
      repozare_check: 'Repozare corecta',
      myEntities: 'Utilizator simbol',
      pdfs: 'Pdf-uri',
      excels: 'Excel-uri'
    })

    this.filterIcons = Object.freeze({
      done: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        [null]: 'mdi-check-circle'
      },
      edited: {
        1: 'mdi-pencil',
        [-1]: 'mdi-pencil-off',
        [null]: 'mdi-pencil'
      },
      photos: {
        1: 'mdi-image-multiple',
        [-1]: 'mdi-image-off',
        [null]: 'mdi-camera'
      },
      repozare: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      repozare_done: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      repozare_check: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      myEntities: {
        1: 'mdi-account-star',
        [-1]: 'mdi-account-remove',
        0: 'mdi-account-multiple',
        [null]: 'mdi-account'
      },
      pdfs: {
        1: 'mdi-file-multiple',
        [-1]: 'mdi-close',
        [null]: 'mdi-file-pdf-box'
      },
      excels: {
        1: 'mdi-file-multiple',
        [-1]: 'mdi-close',
        [null]: 'mdi-file-excel'
      }
    })

    // possible values:
    // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]
    this.filterText = Object.freeze({
      done: {
        1: 'Finalizate',
        [-1]: 'Nefinalizate',
        [null]: 'Filtru neaplicat'
      },
      edited: {
        1: 'Editate',
        [-1]: 'Needitate',
        [null]: 'Filtru neaplicat'
      },
      photos: {
        1: 'Cu Poze',
        [-1]: 'Fara Poze',
        [null]: 'Filtru neaplicat'
      },
      repozare: {
        1: 'Cu Repozare',
        [-1]: 'Fara Repozare',
        0: 'Repozare nesetata',
        [null]: 'Filtru neaplicat'
      },
      repozare_done: {
        1: 'Repozare incheiata',
        [-1]: 'Repozare neincheiata',
        0: 'Nerepozat',
        [null]: 'Filtru neaplicat'
      },
      repozare_check: {
        1: 'Repozare corecta',
        [-1]: 'Repozare incorecta',
        0: 'Neverificat',
        [null]: 'Filtru neaplicat'
      },
      myEntities: {
        1: 'Simbolurile mele',
        [-1]: 'Simboluri neatribuite',
        0: 'Simbolurile altora',
        [null]: 'Filtru neaplicat'
      },
      pdfs: {
        1: 'Cu Pdf-uri',
        [-1]: 'Fara Pdf-uri',
        [null]: 'Filtru neaplicat'
      },
      excels: {
        1: 'Cu Excel-uri',
        [-1]: 'Fara Excel-uri',
        [null]: 'Filtru neaplicat'
      }
    })

    this.filterColors = Object.freeze({
      light: {
        1: 'success',
        [-1]: 'error',
        0: 'primary',
        [null]: 'blue-grey'
      },
      dark: {
        1: 'success',
        [-1]: 'error',
        0: 'primary lighten-2',
        [null]: 'grey lighten-2'
      }
    })
  },
  mounted () {
    // if (this.tab === 'photos' && this.showGallery && this.showPreview) {
    //   this.initializeEditor()
    // }
    this.$store.dispatch('entities/fetchUsernames')
  }
}
</script>

<style lang="stylus">
.components-container {
  position: relative;
  height: 100%;
}

.tui-image-editor-header {
  /* visibility: hidden; */
  display: none;
}

.symbol {
  opacity: .55;
  border: 2px dashed #CFD8DC;
  border-radius: 100%;
  padding: 26px;
}

.opacity1 {
  opacity: 1 !important;
}

.symbol.selected-symbol{
  border-color: var(--v-primary-base);
  border-style: solid;
}
.symbol.delete-enabled{
  border-color: var(--v-error-base);
  border-style: dashed;
}
.symbol.toDelete{
  border-style: solid;
}

.map-container {
  flex-grow: 1;
  width: 100%;
  height: 100%;
}

.file-container, .symbol-container {
  --tile-width: 96px;
  --tile-height: 136px;
  --avatar-size: 48px;
  --primary-color: var(--v-primary-base);
  --delete-color: var(--v-error-base);
  --item-bg-color: #607D8B25;
  --item-border-color: #607D8BF0;
  --avatar-border-color: #607D8B50;

  flex-grow: 1;
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(var(--tile-width), 1fr));
  grid-template-rows: repeat(auto-fill, var(--tile-height));
  gap: 6px 2px;
  overflow-y: scroll;

  &.delete-enabled {
    --avatar-border-color: var(--delete-color);
  }

  .item {
    contain-intrinsic-size: var(--tile-width) var(--tile-height);
    content-visibility: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 2px;
    border-radius: 6px;
    height: var(--tile-height);
    width: var(--tile-width);
    box-sizing: border-box;
    border: 2px solid transparent;
    // transition: all .15s ease-in;
    transition: none;

    &:hover {
      cursor: pointer;
      background-color: var(--item-bg-color);
      border: thin solid var(--item-border-color);

      .avatar {
        img, i {
          filter: brightness(1.1) contrast(1.1) saturate(2);
          scale: 1;
        }
      }
    }

    &.selected {
      background-color: var(--item-bg-color);
      border: thin solid var(--item-border-color);
      color: var(--primary-color);

      .avatar {
        img, i {
          border: 2px solid var(--primary-color);
        }
        img {
          background-color: var(--primary-color);
        }
        i {
          color: var(--primary-color);
        }
      }
    }

    &.to-delete {
      color: var(--delete-color);

      .avatar {
        img, i {
          border: 2px solid var(--delete-color);
        }
        img {
          background-color: var(--delete-color);
        }
        i {
          color: var(--delete-color);
        }
      }
    }

    .avatar {
      width: var(--avatar-size);
      height: var(--avatar-size);

      img, i {
        image-orientation: from-image;
        scale: 0.9;
        filter: brightness(1) contrast(1) saturate(1);
        width: var(--avatar-size);
        height: var(--avatar-size);
        // font-size: var(--avatar-size);
        border-radius: 25%;
        border: 2px dashed var(--avatar-border-color);
        padding: 2px;
        box-sizing: border-box;
        // transition: all .15s ease-in;
        transition: none;
      }
    }

    .text-truncation {
      width: 100%;
      overflow-wrap: break-word;
      font-size: .75em;
      text-align: center;
      overflow: hidden;
    }

    .text-bold {
      font-weight: bold;
    }

    .two-line {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .one-line {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .controls {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .text-truncation {
        width: fit-content;
      }
    }

    .v-icon {
      font-size: inherit;
      color: inherit;
    }
  }
}

.symbol-container {
  --tile-width: 128px;
  --tile-height: 128px;
  --avatar-size: 64px;
}

// .gallery-container {
//   --tile-width: 128px;
//   --tile-height: 128px;
//   --avatar-size: 56px;
//   --primary-color: var(--v-primary-base);
//   --delete-color: var(--v-error-base);
//   --item-bg-color: #607D8B25;
//   --avatar-border-color: #607D8B50;
//   --content-selected-bg-color: var(--v-primary-base);
//   --content-delete-bg-color: var(--v-error-base);
//   --border-radius: 10px;

//   &.light {
//     --content-bg-color: #F5F5F5F0;
//     --item-border-color: #F5F5F5F0;
//   }
//   &.dark {
//     --content-bg-color: #212121F0;
//     --item-border-color: #212121F0;
//   }

//   display: grid;
//   justify-items: center;
//   grid-template-columns: repeat(auto-fill, minmax(var(--tile-width), 1fr));
//   gap: 12px 8px;
//   overflow-y: scroll;

//   &.delete-enabled {
//     --avatar-border-color: var(--delete-color);
//   }

//   .item {
//     content-visibility: auto;
//     contain-intrinsic-size: var(--tile-width) var(--tile-height);
//     border-radius: var(--border-radius);
//     height: var(--tile-height);
//     width: var(--tile-width);
//     box-sizing: border-box;
//     position: relative;
//     border: 2px dashed var(--item-border-color);

//     &:hover {
//       cursor: pointer;
//       background-color: var(--item-bg-color);
//       border: 2px solid var(--item-border-color);

//       .avatar img {
//         filter: brightness(1.1) contrast(1.1) saturate(2);
//         scale: 1;
//       }
//     }

//     &.selected {
//       border: 2px solid var(--primary-color);

//       .content {
//         background-color: var(--content-selected-bg-color);
//       }
//     }

//     &.to-delete {
//       border: thin solid var(--delete-color);

//       .content {
//         background-color: var(--content-delete-bg-color);
//       }
//     }

//     .avatar {
//       width: 100%;
//       height: 100%;
//       border: 2px solid transparent;
//       border-radius: var(--border-radius);
//       background-color: transparent;
//       box-sizing: border-box;

//       img {
//         scale: 1;
//         filter: brightness(1) contrast(1) saturate(1);
//         width: 100%;
//         height: 100%;
//         border-radius: var(--border-radius);
//         /* border: 2px solid transparent; */
//         padding: 0;
//         box-sizing: border-box;
//         object-fit: cover;
//         object-position: center center;
//       }
//     }

//     .content {
//       position: relative;
//       transform: translateY(calc(-100% - 2px));
//       width: calc(100% - 4px);
//       left: 2px;
//       height: fit-content;
//       max-height: 80%;
//       background-color: var(--content-bg-color);
//       /* border: 2px solid transparent; */
//       box-sizing: border-box;
//       color: inherit;
//       border-radius: 0 0 var(--border-radius) var(--border-radius);
//     }

//     .text-truncation {
//       width: 100%;
//       overflow-wrap: break-word;
//       font-size: .75em;
//       text-align: center;
//       overflow: hidden;
//       padding: 2px;
//     }

//     .text-bold {
//       font-weight: bold;
//     }

//     .two-line {
//       display: -webkit-box;
//       -webkit-line-clamp: 2;
//       -webkit-box-orient: vertical;
//     }

//     .one-line {
//       display: -webkit-box;
//       -webkit-line-clamp: 1;
//       -webkit-box-orient: vertical;
//     }

//     .controls {
//       width: 100%;
//       display: flex;
//       flex-direction: row;
//       justify-content: space-evenly;

//       .text-truncation {
//         width: fit-content;
//       }
//     }

//     .v-icon {
//       font-size: inherit;
//       color: inherit;
//     }
//   }
// }

.viewer-title {
  background-color: #000;
  opacity: 1;
  padding: 6px;
  font-size: 1.5rem;
}
</style>
